// import website from '../assets/website.png'
import instagram from '../assets/instagram.png'
// import appstore from '../assets/playstore.png'
// import youtube from '../assets/youtube.jpeg'
// import dribbble from '../assets/dribbble.png'
import github from '../assets/github.png'
//import telegram from '../assets/telegram.png'
import linkedin from '../assets/linkedin.png'
import Music from '../assets/Music.png'
// import personallogo from '../assets/personalsite.png'
import twitter from '../assets/twitter.png'


const items = [
// {

{
    "title": "Music",
    "subtitle": "@prikshit-batra | Follow me",
    "image": Music,
    "link": "https://music.apple.com/profile/pbrick" //Linkedin Profile link
},
{
    "title": "Linkedin",
    "subtitle": "@prikshit-batra | Connect with me",
    "image": linkedin,
    "link": "https://www.linkedin.com/in/prikshit-batra/" //Linkedin Profile link
},
{
    "title": "Instagram",
    "subtitle": "@prikshit.batra | Follow me",
    "image": instagram,
    "link": "https://www.instagram.com/prikshit.batra/" //instagram profile link 
},
{
    "title": "GitHub",
    "subtitle": "@PrikshitBatra",
    "image": github,
    "link": "https://github.com/PrikshitBatra" //Github Profile link
},
{
    "title": "Twitter",
    "subtitle": "@PrikshitBatra",
    "image": twitter,
    "link": "https://twitter.com/PrikshitBatra" //Twitter Profile link
},
]

export default items
